import React, { useEffect, useRef } from 'react';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { BlockSelectModal } from './BlockSelectModal';
import { ClickableIcon } from '@client/new/components/basic';
import { F0 } from '@client/new/helpers/types';
import { useOptionalCreator } from '../LandingPageBuilder';
import { ISection } from '../types';
import { isEmpty } from 'lodash';
import { getSectionsForBuilder, BuilderType } from '../section-config';
import { BusinessModel } from '@playbook-technologies/common-enums';

type Props = {
  onAdd: (o: ISection['type']) => void;
  hasOfferId?: boolean;
  hasSubscriptionOffer?: boolean;
  hasOtpOffers?: boolean;
  builderType?: BuilderType;
};

export function AddSection({
  onAdd,
  hasOfferId,
  hasSubscriptionOffer,
  hasOtpOffers,
  builderType,
}: Props) {
  const [show, setShow] = React.useState(false);
  const ref = useRef<{ focus: F0 }>(null);

  const creator = useOptionalCreator();

  const isOTPOnly =
    creator &&
    !isEmpty(creator.publishedPrograms) &&
    creator.publishedPrograms.every((p) => p.accessType === 'exclusive');

  const isLegacyCreator = creator?.businessModel === BusinessModel.Legacy;

  const effectiveBuilderType =
    builderType ??
    (isLegacyCreator ? 'channel-landing-page' : 'offer-channel-landing-page');

  const tabs = getSectionsForBuilder(effectiveBuilderType, {
    isOTPOnly,
    hasOfferId,
    hasSubscriptionOffer,
    hasOtpOffers,
  });

  useEffect(() => {
    if (show && ref.current) ref.current.focus();
  }, [show]);

  return (
    <>
      <BlockSelectModal
        onClose={() => setShow(false)}
        onSelect={onAdd}
        isOpen={show}
        tabs={tabs}
      />
      <div className="text-xl w-10 h-10 bg-[#E1E5F0] rounded-lg flex items-center justify-center">
        <ClickableIcon
          icon={faPlus}
          onClick={() => setShow(true)}
          title="Add new block"
        />
      </div>
    </>
  );
}
